(() => {
  const roots = document.querySelectorAll('[data-zv-track]');
  if (!roots.length) return;

  const syncHeaderHeight = () => {
    const header = document.querySelector('.shopify-section-header');
    const height = header ? Math.round(header.getBoundingClientRect().height) : 76;
    roots.forEach((root) => {
      const section = root.closest('.zv-track-section');
      if (section) section.style.setProperty('--zvt-header-height', `${height}px`);
    });
  };

  syncHeaderHeight();
  if ('ResizeObserver' in window) {
    const header = document.querySelector('.shopify-section-header');
    if (header) new ResizeObserver(syncHeaderHeight).observe(header);
  } else {
    window.addEventListener('resize', syncHeaderHeight, { passive: true });
  }

  const demoShipment = {
    transportNumber: 'T10000000000001',
    orderNumber: 'ZV-voorbeeld',
    transportDate: '2026-08-14',
    addressLine: 'Bonnetstraat 53',
    city: 'Ede',
    latest: {
      code: '30',
      phase: 'depot',
      title: 'Aangekomen bij een depot',
      summary: 'De zending is gescand bij een TransMission-depot. Een bezorgmoment is nog niet bevestigd.',
      sourceDescription: 'Aankomst Scan',
      occurredAt: '2026-08-15T12:30:00+02:00',
      depot: '3900'
    },
    history: [
      {
        code: '30',
        title: 'Aangekomen bij een depot',
        sourceDescription: 'Aankomst Scan',
        occurredAt: '2026-08-15T12:30:00+02:00',
        depot: '3900',
        scanCount: 4,
        unitCount: 4,
        details: [
          { unitNumber: '1', occurredAt: '2026-08-15T12:30:00+02:00', depot: '3900' },
          { unitNumber: '2', occurredAt: '2026-08-15T12:31:00+02:00', depot: '3900' },
          { unitNumber: '3', occurredAt: '2026-08-15T12:31:00+02:00', depot: '3900' },
          { unitNumber: '4', occurredAt: '2026-08-15T12:32:00+02:00', depot: '3900' }
        ]
      },
      {
        code: '20',
        title: 'Je levering is onderweg',
        sourceDescription: 'Vertrek Scan',
        occurredAt: '2026-08-14T18:10:00+02:00',
        depot: '1000',
        scanCount: 4,
        unitCount: 4,
        details: [
          { unitNumber: '1', occurredAt: '2026-08-14T18:10:00+02:00', depot: '1000' },
          { unitNumber: '2', occurredAt: '2026-08-14T18:11:00+02:00', depot: '1000' },
          { unitNumber: '3', occurredAt: '2026-08-14T18:11:00+02:00', depot: '1000' },
          { unitNumber: '4', occurredAt: '2026-08-14T18:12:00+02:00', depot: '1000' }
        ]
      }
    ],
    scans: [],
    parts: { count: 4, types: ['EP'] },
    delivery: { state: 'unknown', occurredAt: null },
    availability: { expectedDeliveryDate: false, deliveryWindow: false, trackingUrl: false }
  };

  // Translate only verified source wording; never guess an unfamiliar carrier status.
  const carrierMessages = {
    "Aangekomen bij een depot": window.ZinVoltI18n.t("arrived_at_a_depot_5e67eb"),
    "De zending is gescand bij een TransMission-depot. Een bezorgmoment is nog niet bevestigd.": window.ZinVoltI18n.t("the_shipment_was_scanned_at_a_transmission_3a8970"),
    "Je levering is onderweg": window.ZinVoltI18n.t("your_delivery_is_on_its_way_45c197"),
    "Bezorging verhinderd": window.ZinVoltI18n.t("delivery_could_not_be_completed_0c63c3"),
    "De bezorger kon je levering niet afleveren. Maak een nieuwe bezorgafspraak bij TransMission.": window.ZinVoltI18n.t("the_driver_could_not_deliver_your_shipment_f7f169"),
  };
  const carrierText = (value, fallback) => {
    if (!value) return fallback;
    const original = String(value);
    if (!window.ZinVoltI18n.isEnglish) return original;
    return Object.prototype.hasOwnProperty.call(carrierMessages, original)
      ? carrierMessages[original]
      : window.ZinVoltI18n.t("original_carrier_message_message_32040b", {message:original});
  };

  const messages = {
    invalid_lookup: window.ZinVoltI18n.t("check_the_transport_number_and_postcode_the_80e1aa"),
    tracking_not_found: window.ZinVoltI18n.t("we_cannot_find_this_combination_check_the_019268"),
    too_many_requests: window.ZinVoltI18n.t("you_have_made_too_many_searches_wait_c3c596"),
    origin_not_allowed: window.ZinVoltI18n.t("this_tracking_page_cannot_be_used_here_f79ea1"),
    service_not_configured: window.ZinVoltI18n.t("the_tracking_service_is_not_available_yet_5e864b"),
    upstream_authentication_failed: window.ZinVoltI18n.t("the_tracking_service_is_temporarily_unavailable_please_453468"),
    upstream_unavailable: window.ZinVoltI18n.t("transmission_is_temporarily_unavailable_please_try_again_5351fb"),
    incomplete_upstream_response: window.ZinVoltI18n.t("the_tracking_details_could_not_be_loaded_1dd4a2"),
    default: window.ZinVoltI18n.t("something_went_wrong_while_fetching_the_tracking_840fc9")
  };

  const formatMoment = (value) => {
    if (!value) return window.ZinVoltI18n.t("time_unknown_43a022");
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return window.ZinVoltI18n.t("time_unknown_43a022");
    return new Intl.DateTimeFormat(window.ZinVoltI18n.locale, {
      dateStyle: 'long',
      timeStyle: 'short',
      timeZone: 'Europe/Amsterdam'
    }).format(date);
  };

  const formatDeliveryDate = (value) => {
    if (!value) return '';
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value));
    const date = match
      ? new Date(`${match[1]}-${match[2]}-${match[3]}T12:00:00+02:00`)
      : new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat(window.ZinVoltI18n.locale, {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      timeZone: 'Europe/Amsterdam'
    }).format(date);
  };

  const dateValue = (value) => {
    const parsed = new Date(value || '').getTime();
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  const isRescheduleScan = (entry) => String(entry?.code || '') === '301';

  /* De Worker houdt technische scans en de klanttijdlijn bewust gescheiden.
     Daardoor kan een nieuwe, bevestigde 301-scan al wel bij de technische
     details staan terwijl `latest` nog de voorgaande depotscan bevat. Totdat
     de actieve Workerbron veilig is gesynchroniseerd, corrigeren we uitsluitend
     deze officieel bevestigde uitzonderingssituatie in de presentatie-laag. */
  const buildCustomerView = (source) => {
    const shipment = source && typeof source === 'object' ? source : {};
    const delivery = shipment.delivery || {};
    const isDelivered = delivery.state === 'delivered' || shipment.latest?.phase === 'delivered';
    if (isDelivered) return shipment;

    const scans = Array.isArray(shipment.scans) ? shipment.scans : [];
    const rescheduleScan = scans
      .filter(isRescheduleScan)
      .sort((left, right) => dateValue(right.occurredAt) - dateValue(left.occurredAt))[0]
      || (isRescheduleScan(shipment.latest) ? shipment.latest : null);

    if (!rescheduleScan) return shipment;

    const rescheduleTime = dateValue(rescheduleScan.occurredAt);
    const currentTime = dateValue(shipment.latest?.occurredAt);
    if (currentTime > rescheduleTime && !isRescheduleScan(shipment.latest)) return shipment;

    const appointmentStatus = {
      code: '301',
      phase: 'delivery_exception',
      title: 'Bezorging verhinderd',
      summary: 'De bezorger kon je levering niet afleveren. Maak een nieuwe bezorgafspraak bij TransMission.',
      sourceDescription: rescheduleScan.sourceDescription || 'Niet thuis-kaart in de bus gedaan',
      occurredAt: rescheduleScan.occurredAt || null,
      depot: rescheduleScan.depot || null,
      scanCount: Number(rescheduleScan.scanCount || 1),
      unitCount: Number(rescheduleScan.unitCount || shipment.parts?.count || 1),
      details: Array.isArray(rescheduleScan.details) ? rescheduleScan.details : []
    };

    const customerHistory = (Array.isArray(shipment.history) ? shipment.history : [])
      .filter((entry) => String(entry?.code || '') !== '188' && !isRescheduleScan(entry));
    customerHistory.push(appointmentStatus);
    customerHistory.sort((left, right) => dateValue(right.occurredAt) - dateValue(left.occurredAt));

    return {
      ...shipment,
      latest: appointmentStatus,
      history: customerHistory,
      delivery: {
        ...delivery,
        state: 'reschedule_required',
        occurredAt: appointmentStatus.occurredAt,
        expectedDate: null,
        windowStart: null,
        windowEnd: null
      },
      actions: {
        ...(shipment.actions || {}),
        deliveryAppointment: { available: true }
      }
    };
  };

  const deliveryPresentation = (shipment) => {
    const delivery = shipment?.delivery || {};
    const delivered = delivery.state === 'delivered' || shipment.latest?.phase === 'delivered';

    if (delivered) {
      return {
        visible: true,
        title: window.ZinVoltI18n.t("delivered_0f3f60"),
        note: delivery.occurredAt ? window.ZinVoltI18n.t("delivered_on_moment_56d50c", {moment:formatMoment(delivery.occurredAt)}) : window.ZinVoltI18n.t("your_delivery_has_arrived_525142")
      };
    }

    const rescheduleRequired = delivery.state === 'reschedule_required'
      || shipment.latest?.phase === 'delivery_exception'
      || isRescheduleScan(shipment.latest);

    if (rescheduleRequired) {
      return {
        visible: true,
        reschedule: true,
        title: window.ZinVoltI18n.t("new_delivery_appointment_needed_738407"),
        note: window.ZinVoltI18n.t("choose_a_new_delivery_appointment_with_transmission_d1ba0e")
      };
    }

    const dateLabel = formatDeliveryDate(delivery.expectedDate);
    const from = delivery.windowStart || '';
    const to = delivery.windowEnd || '';

    if (dateLabel && from && to) {
      return { visible: true, title: dateLabel, note: window.ZinVoltI18n.t("expected_between_from_and_to_c84393", {from,to}) };
    }
    if (dateLabel && (from || to)) {
      return { visible: true, title: dateLabel, note: window.ZinVoltI18n.t("expected_around_time_8bc01a", {time:from || to}) };
    }
    if (dateLabel) {
      return { visible: true, title: dateLabel, note: window.ZinVoltI18n.t("this_is_the_currently_confirmed_delivery_date_1964bf") };
    }
    if (from && to) {
      return { visible: true, title: `${from} – ${to}`, note: window.ZinVoltI18n.t("this_is_the_currently_confirmed_time_slot_08f926") };
    }

    return { visible: false, title: '', note: '' };
  };

  const text = (root, selector, value) => {
    const node = root.querySelector(selector);
    if (node) node.textContent = value ?? '';
  };

  const buildTimelineItem = (entry, index) => {
    const item = document.createElement('li');
    item.className = `zv-track__timeline-item${index === 0 ? ' is-current' : ''}`;

    const marker = document.createElement('span');
    marker.className = 'zv-track__timeline-marker';
    marker.setAttribute('aria-hidden', 'true');

    const body = document.createElement('div');
    body.className = 'zv-track__timeline-body';

    const heading = document.createElement('div');
    heading.className = 'zv-track__timeline-heading';
    const title = document.createElement('h3');
    title.textContent = carrierText(entry.title || entry.sourceDescription, window.ZinVoltI18n.t("status_update_b9ffba"));
    const moment = document.createElement('time');
    moment.dateTime = entry.occurredAt || '';
    moment.textContent = formatMoment(entry.occurredAt);
    heading.append(title, moment);

    const meta = document.createElement('p');
    const metaParts = [];
    if (entry.depot) metaParts.push(`Depot ${entry.depot}`);
    if (entry.unitCount) metaParts.push(window.ZinVoltI18n.t("count_unit_191442", {count:entry.unitCount,unit:entry.unitCount === 1 ? window.ZinVoltI18n.t("part_7b1747") : window.ZinVoltI18n.t("parts_e476a9")}));
    meta.textContent = metaParts.join(' · ');

    body.append(heading);
    if (meta.textContent) body.append(meta);

    const partDetails = Array.isArray(entry.details)
      ? entry.details.filter((detail) => detail && (detail.unitNumber || detail.occurredAt))
      : [];

    if ((entry.unitCount || 0) > 1 && partDetails.length > 1) {
      const details = document.createElement('details');
      details.className = 'zv-track__part-details';

      const summary = document.createElement('summary');
      const summaryText = document.createElement('span');
      summaryText.textContent = window.ZinVoltI18n.t("view_count_parts_47d075", {count:entry.unitCount});
      summary.append(summaryText);
      summary.insertAdjacentHTML(
        'beforeend',
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>'
      );

      const list = document.createElement('div');
      list.className = 'zv-track__part-list';

      partDetails.forEach((detail, detailIndex) => {
        const row = document.createElement('div');
        row.className = 'zv-track__part-row';

        const label = document.createElement('strong');
        label.textContent = detail.unitNumber ? window.ZinVoltI18n.t("part_number_d5d1f7", {number:detail.unitNumber}) : `Scan ${detailIndex + 1}`;

        const info = document.createElement('span');
        const infoParts = [];
        if (detail.occurredAt) infoParts.push(formatMoment(detail.occurredAt));
        if (detail.depot) infoParts.push(`Depot ${detail.depot}`);
        info.textContent = infoParts.join(' · ');

        row.append(label, info);
        list.append(row);
      });

      details.append(summary, list);
      body.append(details);
    }

    item.append(marker, body);
    return item;
  };

  const buildScanRow = (entry) => {
    const row = document.createElement('div');
    row.className = 'zv-track__scan-row';
    const code = document.createElement('span');
    code.className = 'zv-track__scan-code';
    code.textContent = entry.code ? `Code ${entry.code}` : window.ZinVoltI18n.t("unknown_code_d425f4");
    const copy = document.createElement('div');
    const title = document.createElement('strong');
    title.textContent = carrierText(entry.sourceDescription || entry.title, window.ZinVoltI18n.t("status_update_b9ffba"));
    const meta = document.createElement('span');
    meta.textContent = `${formatMoment(entry.occurredAt)}${entry.depot ? ` · depot ${entry.depot}` : ''}`;
    copy.append(title, meta);
    row.append(code, copy);
    return row;
  };

  roots.forEach((root) => {
    const form = root.querySelector('[data-zv-track-form]');
    const lookup = root.querySelector('[data-zv-track-lookup]');
    const results = root.querySelector('[data-zv-track-results]');
    const submit = root.querySelector('[data-zv-track-submit]');
    const error = root.querySelector('[data-zv-track-form-error]');
    const live = root.querySelector('[data-zv-track-live]');
    const endpoint = root.dataset.apiEndpoint || '';
    const demoMode = root.dataset.demoMode === 'true';
    let verifiedPostcode = '';
    let directLookup = false;
    let activeLookup = null;

    if (!form || !lookup || !results || !submit) return;

    const setLoading = (isLoading) => {
      submit.disabled = isLoading;
      submit.setAttribute('aria-busy', String(isLoading));
      root.classList.toggle('is-loading', isLoading);
      text(root, '[data-zv-track-submit-label]', isLoading ? window.ZinVoltI18n.t("fetching_tracking_details_3d51ee") : window.ZinVoltI18n.t("view_my_delivery_00cf49"));
    };

    const showError = (message) => {
      document.documentElement.classList.remove('zv-track-direct-loading');
      error.textContent = message;
      error.hidden = false;
      live.textContent = message;
      error.focus?.();
    };

    const updateTrackingUrl = (payload) => {
      if (!payload?.transport_number || !payload?.postcode) return;
      const parameters = new URLSearchParams({
        transport: payload.transport_number,
        postcode: payload.postcode
      });
      window.history.replaceState(
        null,
        '',
        `${window.location.pathname}${window.location.search}#${parameters.toString()}`
      );
    };

    const render = (shipment) => {
      shipment = buildCustomerView(shipment);
      text(root, '[data-zv-track-status-title]', carrierText(shipment.latest?.title, window.ZinVoltI18n.t("status_update_received_e85afe")));
      text(root, '[data-zv-track-status-summary]', carrierText(shipment.latest?.summary, window.ZinVoltI18n.t("transmission_has_recorded_a_status_update_ac7cd4")));
      text(root, '[data-zv-track-transport]', shipment.transportNumber || '—');
      const destination = [
        shipment.addressLine,
        verifiedPostcode.replace(/^(\d{4})([A-Z]{2})$/, '$1 $2'),
        shipment.city
      ].filter(Boolean).join(' · ');
      text(root, '[data-zv-track-destination]', destination || window.ZinVoltI18n.t("destination_confirmed_cd8a09"));

      const originalTrack = root.querySelector('[data-zv-track-original-track]');
      if (originalTrack && shipment.transportNumber && verifiedPostcode) {
        originalTrack.href = `https://api.trans-mission.nl/tt/${encodeURIComponent(shipment.transportNumber)}/${encodeURIComponent(verifiedPostcode)}`;
      }

      const count = Number(shipment.parts?.count || 0);
      const history = Array.isArray(shipment.history) ? shipment.history : [];
      const delivery = deliveryPresentation(shipment);
      const delivered = shipment.delivery?.state === 'delivered' || shipment.latest?.phase === 'delivered';

      root.classList.toggle('is-delivered', delivered);
      root.dataset.statusPhase = shipment.latest?.phase || 'update';

      const dashboard = root.querySelector('[data-zv-track-dashboard]');
      const timelineCard = root.querySelector('[data-zv-track-timeline-card]');
      const partsCard = root.querySelector('[data-zv-track-parts-card]');
      const deliveryCard = root.querySelector('[data-zv-track-delivery-card]');
      const appointmentForm = root.querySelector('[data-zv-track-appointment-form]');
      const technical = root.querySelector('[data-zv-track-technical]');

      const hasTimeline = history.length > 0;
      const hasParts = Number.isFinite(count) && count > 0;
      const hasDelivery = delivery.visible;

      if (timelineCard) timelineCard.hidden = !hasTimeline;
      if (partsCard) partsCard.hidden = !hasParts;
      if (deliveryCard) deliveryCard.hidden = !hasDelivery;
      const canReschedule = Boolean(
        delivery.reschedule
        && shipment.actions?.deliveryAppointment?.available !== false
        && shipment.transportNumber
        && verifiedPostcode
      );
      root.classList.toggle('is-reschedule-required', canReschedule);
      if (appointmentForm) {
        appointmentForm.hidden = !canReschedule;
        const shipmentField = appointmentForm.querySelector('[name="shipment_id"]');
        const postcodeField = appointmentForm.querySelector('[name="zipcode"]');
        if (shipmentField) shipmentField.value = canReschedule ? shipment.transportNumber : '';
        if (postcodeField) postcodeField.value = canReschedule ? verifiedPostcode : '';
      }
      if (technical) technical.hidden = !hasTimeline;
      if (dashboard) {
        dashboard.hidden = !(hasTimeline || hasParts || hasDelivery);
        dashboard.classList.toggle('zv-track__dashboard--no-timeline', !hasTimeline && (hasParts || hasDelivery));
      }

      if (hasParts) {
        text(root, '[data-zv-track-parts]', window.ZinVoltI18n.t("count_unit_191442", {count:count,unit:count === 1 ? window.ZinVoltI18n.t("part_7b1747") : window.ZinVoltI18n.t("parts_e476a9")}));
        text(
          root,
          '[data-zv-track-parts-note]',
          count === 1
            ? window.ZinVoltI18n.t("this_delivery_consists_of_one_part_cd9cc8")
            : window.ZinVoltI18n.t("this_delivery_consists_of_multiple_parts_scans_234e02")
        );
      }

      if (hasDelivery) {
        text(root, '[data-zv-track-delivery-title]', delivery.title);
        text(root, '[data-zv-track-delivery-note]', delivery.note);
      }

      const timeline = root.querySelector('[data-zv-track-timeline]');
      const scans = root.querySelector('[data-zv-track-scans]');
      const technicalScans = Array.isArray(shipment.scans) ? shipment.scans : history;
      if (timeline) {
        timeline.replaceChildren();
        history.forEach((entry, index) => timeline.append(buildTimelineItem(entry, index)));
      }
      if (scans) {
        scans.replaceChildren();
        technicalScans.forEach((entry) => scans.append(buildScanRow(entry)));
      }

      lookup.hidden = true;
      results.hidden = false;
      root.classList.add('has-results');
      document.body.classList.add('zv-track-results-active');
      document.documentElement.classList.remove('zv-track-direct-loading');
      updateTrackingUrl(activeLookup);
      live.textContent = window.ZinVoltI18n.t("status_found_status_3e53e3", {status:carrierText(shipment.latest?.title, window.ZinVoltI18n.t("status_update_received_b6cdc2"))});
      results.querySelector('h2')?.focus({ preventScroll: true });
      window.requestAnimationFrame(() => {
        if (directLookup) {
          window.scrollTo({ top: 0, behavior: 'auto' });
        } else {
          results.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      error.hidden = true;
      const data = new FormData(form);
      const payload = {
        transport_number: String(data.get('transport_number') || '').toUpperCase().replace(/[\s-]+/g, ''),
        postcode: String(data.get('postcode') || '').toUpperCase().replace(/\s+/g, '')
      };

      if (!/^T\d{14}$/.test(payload.transport_number) || !/^\d{4}[A-Z]{2}$/.test(payload.postcode)) {
        showError(messages.invalid_lookup);
        return;
      }
      verifiedPostcode = payload.postcode;
      activeLookup = payload;

      setLoading(true);
      try {
        if (demoMode) {
          await new Promise((resolve) => window.setTimeout(resolve, 450));
          render({ ...demoShipment, transportNumber: payload.transport_number });
          return;
        }
        if (!endpoint) throw new Error('service_not_configured');

        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          credentials: 'omit',
          cache: 'no-store',
          referrerPolicy: 'no-referrer'
        });
        const body = await response.json().catch(() => ({}));
        if (!response.ok || !body.ok || !body.shipment) throw new Error(body.error || 'default');
        render(body.shipment);
      } catch (caught) {
        showError(messages[caught.message] || messages.default);
      } finally {
        setLoading(false);
      }
    });

    /* Directe trackinglinks gebruiken bewust het URL-fragment. Een fragment
       wordt niet naar Shopify, TransMission of een verwijzende website
       meegestuurd. Na een geslaagde controle blijft de genormaliseerde link
       staan, zodat de klant exact deze levering opnieuw kan openen of delen. */
    const directLink = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const linkedTransport = directLink.get('transport') || directLink.get('transportnummer');
    const linkedPostcode = directLink.get('postcode');

    if (linkedTransport && linkedPostcode) {
      const transportField = form.querySelector('[name="transport_number"]');
      const postcodeField = form.querySelector('[name="postcode"]');
      if (transportField && postcodeField) {
        directLookup = true;
        transportField.value = linkedTransport;
        postcodeField.value = linkedPostcode;
        window.requestAnimationFrame(() => form.requestSubmit());
      }
    }
  });
})();
